<template>
  <div class="container change-my-pro-learn-more">
    <div class="columns">
      <header class="column is-6">
        <LsSupportHeader label="What to expect" back-route="changeMyProvider" />
        <p>Keep in mind before you request a pro change</p>
      </header>
    </div>
    <div class="columns">
      <main class="column is-6">
        <div class="learn-more-info">
          <figure class="icon-wrapper clockf">
            <LsIcon type="clockf" color="primary" size="lg" />
          </figure>
          <p>
            We request a 48 hour notice to make the pro change. If your next service is scheduled
            within that window your original pro will come by to complete the job, and we'll make
            the change for all following services.
          </p>
        </div>
        <div class="learn-more-info">
          <figure class="icon-wrapper">
            <LsIcon type="fertilizer" color="primary" size="lg" />
          </figure>
          <p>
            Lawn Treatment pros are not eligible to be swapped out. We have a limited number of
            these pros as they are licensed professionals applying regulated chemicals.
          </p>
        </div>
      </main>
    </div>
    <div class="columns">
      <footer class="column is-6">
        <LsButton
          class="submit"
          text="ok"
          track-id="change_my_pro-learn_more_ok"
          bg-color="primary"
          @click="$router.push({ name: 'changeMyProvider' })"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';
import { LsIcon, LsButton } from '@/components/common';

export default {
  name: 'LearnMore',
  components: { LsSupportHeader, LsIcon, LsButton },
};
</script>

<style lang="scss" scoped>
.change-my-pro-learn-more {
  header {
    p {
      color: $theme-color-primary;
      margin-top: 1.5rem;
    }
  }
  .icon-wrapper {
    align-items: center;
    border-radius: 50%;
    background-color: $theme-color-primary-light;
    display: flex;
    justify-content: center;
    height: 4rem;
    min-width: 4rem;
    margin-right: 1.5rem;
    &.clockf {
      padding: 0 0 0 0.1rem;
    }
  }
  .learn-more-info {
    align-items: flex-start;
    display: flex;
    justify-content: flex-start;
    & ~ .learn-more-info {
      margin-top: 3rem;
    }
  }
  footer {
    margin-top: 3rem;
  }
}
</style>
